import {makeStyles} from '@material-ui/core';

export const useStyles = makeStyles(theme => {
  return {
    outerContainer: {
      // paddingTop: '1rem',
      // paddingLeft: '1rem',
      // paddingRight: '1rem',
      // paddingBottom: '4.5rem',
      // width: '100%'
    },
    addButtonContainer: {
      marginTop: '10px',
      marginBottom: '10px',
      textAlign: 'right',
    },
    addButton: {
      position: 'absolute',
      marginLeft: '-10rem',
      marginTop: '1rem',
      zIndex: '1',
      textTransform: 'capitalize',
    },
  }
})
